<div class="overview-device {{ sectionclass }}">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="overview-device-heading">Clicks by Device</div>
	<div *ngIf="hasData" class="overview-device-details">
		<div class="desktop-device">
			<div class="desktop-device-svg">
				<svg width="66" height="58" viewBox="0 0 66 58" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g id="desktop-solid 1" clip-path="url(#clip0_2_2642)">
						<path
							id="Vector"
							d="M7.33333 0C3.28854 0 0 3.25117 0 7.25V39.875C0 43.8738 3.28854 47.125 7.33333 47.125H27.5L26.274 50.75H18.3333C16.3052 50.75 14.6667 52.3699 14.6667 54.375C14.6667 56.3801 16.3052 58 18.3333 58H47.6667C49.6948 58 51.3333 56.3801 51.3333 54.375C51.3333 52.3699 49.6948 50.75 47.6667 50.75H39.726L38.5 47.125H58.6667C62.7115 47.125 66 43.8738 66 39.875V7.25C66 3.25117 62.7115 0 58.6667 0H7.33333ZM58.6667 7.25V32.625H7.33333V7.25H58.6667Z"
							fill="#444444"
						/>
					</g>
					<defs>
						<clipPath id="clip0_2_2642">
							<rect width="66" height="58" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</div>
			<div class="desktop-device-data">
				<div class="device-heading">Desktop</div>
				<div class="device-clicks">{{ desktopClicks | number }}</div>
			</div>
		</div>
		<div class="mobile-device">
			<div class="mobile-device-svg">
				<svg width="40" height="54" viewBox="0 0 40 54" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g id="mobile-screen-solid 1" clip-path="url(#clip0_2_2648)">
						<path
							id="Vector"
							d="M1.66666 7.125C1.66666 3.4709 4.65625 0.5 8.33333 0.5H31.6667C35.3438 0.5 38.3333 3.4709 38.3333 7.125V46.875C38.3333 50.5291 35.3438 53.5 31.6667 53.5H8.33333C4.65625 53.5 1.66666 50.5291 1.66666 46.875V7.125ZM15 46.875C15 47.7859 15.75 48.5312 16.6667 48.5312H23.3333C24.25 48.5312 25 47.7859 25 46.875C25 45.9641 24.25 45.2188 23.3333 45.2188H16.6667C15.75 45.2188 15 45.9641 15 46.875ZM31.6667 7.125H8.33333V40.25H31.6667V7.125Z"
							fill="#444444"
						/>
					</g>
					<defs>
						<clipPath id="clip0_2_2648">
							<rect width="40" height="53" fill="white" transform="translate(0 0.5)" />
						</clipPath>
					</defs>
				</svg>
			</div>
			<div class="mobile-device-data">
				<div class="device-heading">Mobile</div>
				<div class="device-clicks">{{ mobileClicks | number }}</div>
			</div>
		</div>
	</div>
	<div *ngIf="!hasData" class="no-data-screen" style="display: table; min-height: 200px; width: 100%">
		<div class="no-data-text">
			<p>No Data Available</p>
		</div>
	</div>
</div>
